// =========================================================
// demo-data.js
// =========================================================
const firstNames = ['Alex','Jordan','Sam','Taylor','Morgan','Riley','Casey','Jamie','Avery','Quinn','Drew','Reese','Cameron','Skylar','Harper','Phoenix','Rowan','Sage','River','Emerson','Blake','Hayden','Parker','Logan','Kendall','Finley','Remi','Sloan','Tatum','Wren','Dakota','Eden','Frankie','Greer','Indigo','Jules','Kai','Lennox','Marlowe','Noor','Ocean','Palmer','Remy','Sasha','Tobin','Uma','Vesper','Wilde','Xen','Yael','Zion','Aria','Bex','Coco','Dion','Ezra','Faye','Gus','Halo','Iris','Jett','Koa','Lux','Mika','Nico','Onyx','Pax','Quill','Rio','Shiloh','True','Vale','Wyn','Xan','Yves','Zev','Aida','Brio','Cleo','Dex','Elio','Fern','Gio','Haven','Ilo','Juno','Kit','Lio','Maeve','Nova','Orion','Pip','Rune','Selah','Taio','Vela','Wim','Xola','Yara','Zara','Mateo','Lucia','Sofia','Hugo','Nina','Oscar','Elsa','Finn','Gala','Hana','Ivo','Jade','Kira','Lars','Mila','Niko','Otis','Pia','Ravi','Suki','Theo','Una','Vito','Wade','Xavi','Yuki','Zane','Amir','Bela','Ciro','Dova','Elin','Fox','Gema','Hiro','Ila','Jax','Kael','Lina','Mio','Nael','Ori','Pax','Rho','Sel','Tal','Umi','Vex','Wyn','Yun','Zola','Anu','Brio','Cael','Dax','Enzo','Fia','Gil','Hox','Iru'];
const lastNames = ['Smith','Johnson','Williams','Brown','Jones','Garcia','Miller','Davis','Rodriguez','Martinez','Hernandez','Lopez','Gonzalez','Wilson','Anderson','Thomas','Taylor','Moore','Jackson','Martin','Lee','Perez','Thompson','White','Harris','Sanchez','Clark','Ramirez','Lewis','Robinson','Walker','Young','Allen','King','Wright','Scott','Torres','Nguyen','Hill','Flores','Green','Adams','Nelson','Baker','Hall','Rivera','Campbell','Mitchell','Carter','Roberts','Gomez','Phillips','Evans','Turner','Diaz','Parker','Cruz','Edwards','Collins','Reyes','Stewart','Morris','Morales','Murphy','Cook','Rogers','Gutierrez','Ortiz','Morgan','Cooper','Peterson','Bailey','Reed','Kelly','Howard','Ramos','Kim','Cox','Ward','Richardson','Watson','Brooks','Chavez','Wood','James','Bennett','Gray','Mendoza','Ruiz','Hughes','Price','Alvarez','Castillo','Sanders','Patel','Myers','Long','Ross','Foster','Jimenez','Powell','Jenkins','Perry','Russell','Sullivan','Bell','Coleman','Butler','Henderson','Barnes','Gonzales','Fisher','Vasquez','Simmons','Romero','Jordan','Patterson','Alexander','Hamilton','Graham','Reynolds','Griffin','Wallace','Moreno','West','Cole','Hayes','Bryant','Herrera','Gibson','Ellis','Tran','Medina','Aguilar','Stevens','Murray','Ford','Castro','Marshall','Owens','Harrison','Fernandez','Mcdonald','Woods','Washington','Kennedy','Wells','Vargas','Henry','Chen','Freeman','Webb','Tucker','Guzman','Burns','Crawford','Mason','Santos','Pena','Hunter'];
const countries = [{ code: 'FR', name: 'France', flag: '🇫🇷' },{ code: 'BR', name: 'Brazil', flag: '🇧🇷' },{ code: 'DE', name: 'Germany', flag: '🇩🇪' },{ code: 'ES', name: 'Spain', flag: '🇪🇸' },{ code: 'AR', name: 'Argentina', flag: '🇦🇷' },{ code: 'PT', name: 'Portugal', flag: '🇵🇹' },{ code: 'NL', name: 'Netherlands', flag: '🇳🇱' },{ code: 'BE', name: 'Belgium', flag: '🇧🇪' },{ code: 'HR', name: 'Croatia', flag: '🇭🇷' },{ code: 'UY', name: 'Uruguay', flag: '🇺🇾' },{ code: 'IT', name: 'Italy', flag: '🇮🇹' },{ code: 'GB', name: 'England', flag: '🏴' },{ code: 'MX', name: 'Mexico', flag: '🇲🇽' },{ code: 'US', name: 'USA', flag: '🇺🇸' },{ code: 'JP', name: 'Japan', flag: '🇯🇵' },{ code: 'KR', name: 'Korea', flag: '🇰🇷' }];
const clubs = ['Paris Elite','Rio Athletic','Berlin FC','Madrid Galactico','Boca United','Lisbon Warriors','Ajax Town','Bruges City','Zagreb FC','Montevideo SC','Roma Golden','London Crown','Mexico Aztec','Los Angeles SC','Tokyo Rising','Seoul Phoenix','Marseille Blue','Lyon Pride','Dortmund Gold','Munich Bavaria'];

function seededRandom(seed) { let s = seed; return () => { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
function generateDemoData() {
  const counts = WINNER_COUNTS;
  const totalWinners = counts.third + counts.runner + counts.champion;
  const rand = seededRandom(73); const participants = [];
  const indices = Array.from({ length: 160 }, (_, i) => i);
  for (let i = indices.length - 1; i > 0; i--) { const j = Math.floor(rand() * (i + 1)); [indices[i], indices[j]] = [indices[j], indices[i]]; }
  const thirdPrizeIds = indices.slice(0, counts.third).sort((a, b) => a - b);
  const runnerUpIds = indices.slice(counts.third, counts.third + counts.runner).sort((a, b) => a - b);
  const grandPrizeId = indices[counts.third + counts.runner];
  for (let i = 0; i < 160; i++) {
    const firstName = firstNames[i % firstNames.length];
    const lastName = lastNames[(i * 7 + 3) % lastNames.length];
    const country = countries[i % countries.length];
    const club = clubs[i % clubs.length];
    const rating = 72 + Math.floor(rand() * 28);
    let tier = 'participant'; let revealOrder = null;
    const thirdIdx = thirdPrizeIds.indexOf(i);
    if (thirdIdx !== -1) { tier = 'third'; revealOrder = thirdIdx + 1; }
    else if (runnerUpIds.includes(i)) { tier = 'runner'; revealOrder = counts.third + 1 + runnerUpIds.indexOf(i); }
    else if (i === grandPrizeId) { tier = 'champion'; revealOrder = totalWinners; }
    participants.push({ id: i + 1, name: `${firstName} ${lastName}`, firstName, lastName, country: country.code, countryName: country.name, flag: country.flag, club, rating, tier, revealOrder });
  }
  return { participants, totalParticipants: participants.length, totalCorrectGuesses: 120, winners: {
      thirdPrize: participants.filter((p) => p.tier === 'third').sort((a, b) => a.revealOrder - b.revealOrder),
      runnerUp: participants.filter((p) => p.tier === 'runner').sort((a, b) => a.revealOrder - b.revealOrder),
      grandPrize: participants.filter((p) => p.tier === 'champion')
  }}; 
} 
function _cfg(key, fallback) { return (window.WC_CONFIG && window.WC_CONFIG[key]) || fallback; }

function getCountryFromClub(club) {
  const mapping = {
    'france': { code: 'FR', name: 'France', flag: '🇫🇷' },
    'brazil': { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
    'germany': { code: 'DE', name: 'Germany', flag: '🇩🇪' },
    'spain': { code: 'ES', name: 'Spain', flag: '🇪🇸' },
    'argentina': { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
    'portugal': { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
    'netherlands': { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
    'belgium': { code: 'BE', name: 'Belgium', flag: '🇧🇪' },
    'croatia': { code: 'HR', name: 'Croatia', flag: '🇭🇷' },
    'uruguay': { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
    'italy': { code: 'IT', name: 'Italy', flag: '🇮🇹' },
    'england': { code: 'GB', name: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
    'mexico': { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
    'usa': { code: 'US', name: 'USA', flag: '🇺🇸' },
    'japan': { code: 'JP', name: 'Japan', flag: '🇯🇵' },
    'korea': { code: 'KR', name: 'Korea', flag: '🇰🇷' },
    'south korea': { code: 'KR', name: 'Korea', flag: '🇰🇷' },
    'morocco': { code: 'MA', name: 'Morocco', flag: '🇲🇦' },
    'senegal': { code: 'SN', name: 'Senegal', flag: '🇸🇳' },
    'serbia': { code: 'RS', name: 'Serbia', flag: '🇷🇸' },
    'switzerland': { code: 'CH', name: 'Switzerland', flag: '🇨🇭' },
    'wales': { code: 'GB', name: 'Wales', flag: '🇬🇧' },
    'poland': { code: 'PL', name: 'Poland', flag: '🇵🇱' },
    'ecuador': { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
    'cameroon': { code: 'CM', name: 'Cameroon', flag: '🇨🇲' },
    'ghana': { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
    'canada': { code: 'CA', name: 'Canada', flag: '🇨🇦' },
    'australia': { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    'iran': { code: 'IR', name: 'Iran', flag: '🇮🇷' },
    'saudi arabia': { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
    'qatar': { code: 'QA', name: 'Qatar', flag: '🇶🇦' },
    'tunisia': { code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
    'denmark': { code: 'DK', name: 'Denmark', flag: '🇩🇰' }
  };
  const key = (club || '').toLowerCase().trim();
  return mapping[key] || { code: 'WW', name: 'World', flag: '🌍' };
}

function computeRating(customerId) {
  const id = parseInt(customerId, 10) || 0;
  return 72 + (Math.abs(id) % 28);
}

function buildWinnerPerson(g) {
  var name = g.customer_name || 'Unknown';
  var parts = name.trim().split(/\s+/);
  var first = parts[0] || 'Unknown';
  var last = parts.slice(1).join(' ') || '';
  var club = g.champion_pick || '';
  var countryInfo = getCountryFromClub(club);
  var rating = computeRating(g.customer_id);
  return {
    id: g.customer_id != null ? String(g.customer_id) : Math.random().toString(36).slice(2),
    name: name,
    firstName: first,
    lastName: last,
    email: g.customer_email || '',
    country: countryInfo.code,
    countryName: countryInfo.name,
    flag: countryInfo.flag,
    club: club,
    rating: rating,
    tier: 'participant',
    revealOrder: parseInt(g.reveal_order || g.guess_order, 10) || 0
  };
}

function normalizeRealData(raw) {
  // Build wall participants from champion_pick entries
  var participants = (raw.participants || []).map(function(p, index) {
    var name = p.customer_name || 'Participant ' + (index + 1);
    var parts = name.trim().split(/\s+/);
    var first = parts[0] || 'Participant';
    var last = parts.slice(1).join(' ') || '';
    var club = p.champion || p.champion_pick || '';
    var countryInfo = getCountryFromClub(club);
    var rating = computeRating(p.customer_id);
    return {
      id: p.customer_id != null ? String(p.customer_id) : index,
      name: name,
      firstName: first,
      lastName: last,
      email: p.customer_email || '',
      country: countryInfo.code,
      countryName: countryInfo.name,
      flag: countryInfo.flag,
      club: club,
      rating: rating,
      tier: 'participant',
      revealOrder: null
    };
  });

  // Build winners directly from correct_guesses by prize_tier
  var guesses = raw.correctGuesses || [];
  var counts = WINNER_COUNTS;

  function matchTier(g, keywords) {
    var t = (g.prize_tier || '').toLowerCase();
    return keywords.some(function(kw) { return t.indexOf(kw) !== -1; });
  }

  var thirdPrize = guesses
    .filter(function(g) { return matchTier(g, ['bronze','3rd','third']); })
    .map(buildWinnerPerson)
    .sort(function(a, b) { return a.revealOrder - b.revealOrder; })
    .slice(0, counts.third)
    .map(function(w) { w.tier = 'third'; return w; });

  var runnerUp = guesses
    .filter(function(g) { return matchTier(g, ['runner','2nd','second','silver']); })
    .map(buildWinnerPerson)
    .sort(function(a, b) { return a.revealOrder - b.revealOrder; })
    .slice(0, counts.runner)
    .map(function(w) { w.tier = 'runner'; return w; });

  var grandPrize = guesses
    .filter(function(g) { return matchTier(g, ['champion','1st','first','grand']); })
    .map(buildWinnerPerson)
    .sort(function(a, b) { return a.revealOrder - b.revealOrder; })
    .slice(0, counts.champion)
    .map(function(w) { w.tier = 'champion'; return w; });

  // Mark matching wall participants as winners (so wall cards get tier styling)
  var winnerById = {};
  [thirdPrize, runnerUp, grandPrize].forEach(function(arr) {
    arr.forEach(function(w) { winnerById[w.id] = w; });
  });
  participants.forEach(function(p) {
    var w = winnerById[p.id];
    if (w) { p.tier = w.tier; p.revealOrder = w.revealOrder; }
  });

  console.log('[WCEREMONY] loaded', participants.length, 'participants,', guesses.length, 'correct guesses. Winners (capped by settings):', grandPrize.length, 'champion,', runnerUp.length, 'runner,', thirdPrize.length, 'third. Limits:', counts);

  return {
    participants: participants,
    totalParticipants: participants.length,
    totalCorrectGuesses: guesses.length,
    winners: { thirdPrize: thirdPrize, runnerUp: runnerUp, grandPrize: grandPrize }
  };
}

const WINNER_COUNTS = (window.WCEREMONY_CONFIG && window.WCEREMONY_CONFIG.winners) || { third: 5, runner: 2, champion: 1 };

let demoData = generateDemoData();
if (window.WCEREMONY_DATA) {
  try {
    demoData = normalizeRealData(window.WCEREMONY_DATA);
  } catch (e) {
    console.error('Failed to normalize ceremony data', e);
  }
}
if (window.WCEREMONY_CONFIG && window.WCEREMONY_CONFIG.totalParticipants) {
  demoData.totalParticipants = window.WCEREMONY_CONFIG.totalParticipants;
}

// =========================================================
// sound.js (Added Background Music Loop)
// =========================================================
const sound = (() => {
  let ctx = null, masterGain = null, ambienceNodes = [], muted = false, initialized = false, musicHowl = null;
  const activeSources = new Set();
  const sfxCache = {};
  const sfxVolumes = {};
  function track(src) {
    activeSources.add(src);
    src.onended = () => { activeSources.delete(src); };
  }
  function stopAll() {
    activeSources.forEach(src => { try { src.stop(); } catch(e) {} });
    activeSources.clear();
    try { window.speechSynthesis && window.speechSynthesis.cancel(); } catch(e) {}
  }
  function loadSFX(name, url, vol) {
    if (!url || !ctx) return;
    sfxVolumes[name] = vol || 1;
    fetch(url).then(r => r.arrayBuffer()).then(buf => ctx.decodeAudioData(buf)).then(decoded => {
      sfxCache[name] = decoded;
    }).catch(() => {});
  }
  function playSFXBuffer(name) {
    const buf = sfxCache[name];
    if (!buf || !ctx || muted) return;
    ensureContext();
    const src = ctx.createBufferSource();
    src.buffer = buf;
    const gain = ctx.createGain();
    gain.gain.value = sfxVolumes[name] || 1;
    src.connect(gain); gain.connect(masterGain);
    track(src);
    src.start();
  }
  function init() {
    if (initialized) return; initialized = true;
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
      masterGain = ctx.createGain(); masterGain.gain.value = 0.2; masterGain.connect(ctx.destination);
    } catch (e) { console.warn('Web Audio API not available:', e); }
  }
  function ensureContext() { if (ctx && ctx.state === 'suspended') { ctx.resume(); } }

  // Background music — uses HTML <audio autoplay muted> then fades in
  function startMusic() {
    if (musicHowl) return;
    const cfg = window.WC_CONFIG || {};
    if (cfg.enableBgMusic === false) return;
    const audio = document.getElementById('bg-music');
    if (!audio) return;
    console.log('[Sound] Starting bg-music...');
    const doFade = () => {
      console.log('[Sound] Playing, fading in...');
      setTimeout(() => {
        if (muted) return;
        audio.muted = false;
        let vol = 0;
        const target = (_lastVol / 100) * 0.10;
        const fade = () => {
          vol += 0.008;
          if (vol < target) { audio.volume = vol; requestAnimationFrame(fade); }
          else { audio.volume = target; }
        };
        requestAnimationFrame(fade);
      }, 600);
    };
    let retries = 0;
    const tryPlay = () => {
      if (!audio.paused) { doFade(); return; }
      audio.play().then(doFade).catch(() => {
        retries++;
        if (retries < 30) { setTimeout(tryPlay, 400); }
      });
    };
    // Retry on first user click (handles autoplay policy)
    const once = () => {
      audio.play().then(doFade).catch(() => {});
      document.removeEventListener('click', once);
      document.removeEventListener('touchstart', once);
    };
    document.addEventListener('click', once);
    document.addEventListener('touchstart', once);
    tryPlay();
    musicHowl = audio;
    window._bgAudio = audio;
  }

  function playWhoosh(duration = 0.5, intensity = 1) {
    if (sfxCache.whoosh) { playSFXBuffer('whoosh'); return; }
    if (!ctx || muted) return; ensureContext(); const now = ctx.currentTime;
    const bufferSize = Math.floor(ctx.sampleRate * duration);
    const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < bufferSize; i++) { data[i] = (Math.random() * 2 - 1) * 0.5; }
    const source = ctx.createBufferSource(); source.buffer = buffer;
    const filter = ctx.createBiquadFilter(); filter.type = 'bandpass';
    filter.frequency.setValueAtTime(200, now);
    filter.frequency.exponentialRampToValueAtTime(3000, now + duration * 0.8);
    filter.frequency.exponentialRampToValueAtTime(200, now + duration); filter.Q.value = 3;
    const gain = ctx.createGain(); gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.4 * intensity, now + duration * 0.2);
    gain.gain.exponentialRampToValueAtTime(0.001, now + duration);
    source.connect(filter); filter.connect(gain); gain.connect(masterGain);
    track(source);
    source.start(now); source.stop(now + duration);
  }
  function playHeartbeat() {
    if (sfxCache.heartbeat) { playSFXBuffer('heartbeat'); return; }
    if (!ctx || muted) return; ensureContext(); const now = ctx.currentTime;
    [{ offset: 0, freq: 60, dur: 0.12 }, { offset: 0.15, freq: 50, dur: 0.15 }].forEach(({ offset, freq, dur }) => {
      const osc = ctx.createOscillator(); osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + offset);
      osc.frequency.exponentialRampToValueAtTime(freq * 0.5, now + offset + dur);
      const gain = ctx.createGain(); gain.gain.setValueAtTime(0, now + offset);
      gain.gain.linearRampToValueAtTime(0.8, now + offset + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, now + offset + dur);
      osc.connect(gain); gain.connect(masterGain);
      track(osc);
      osc.start(now + offset); osc.stop(now + offset + dur + 0.05);
    });
  }
  function playVictory() {
    if (sfxCache.victory) { playSFXBuffer('victory'); return; }
    if (!ctx || muted) { console.log('[victory] skipped: ctx=', !!ctx, 'muted=', muted); return; }
    ensureContext();
    if (ctx.state === 'suspended') { ctx.resume(); setTimeout(() => playVictory(), 100); return; }
    console.log('[victory] playing now');
    const now = ctx.currentTime;
    const notes = [
      { freq: 523.25, t: 0, dur: 0.8 },
      { freq: 659.25, t: 0.3, dur: 0.8 },
      { freq: 783.99, t: 0.6, dur: 1.2 },
      { freq: 1046.50, t: 0.9, dur: 2.0 }
    ];
    notes.forEach(({ freq, t, dur }) => {
      const osc = ctx.createOscillator(); osc.type = 'sine'; osc.frequency.value = freq;
      const gain = ctx.createGain();
      const start = now + t;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.5, start + 0.05);
      gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
      osc.connect(gain); gain.connect(ctx.destination);
      track(osc);
      osc.start(start); osc.stop(start + dur);
    });
  }
  function playTick(highPitch = false) {
    if (sfxCache.tick) { playSFXBuffer('tick'); return; }
    if (!ctx || muted) return; ensureContext(); const now = ctx.currentTime;
    const osc = ctx.createOscillator(); osc.type = 'square'; osc.frequency.value = highPitch ? 1500 : 800;
    const gain = ctx.createGain(); gain.gain.setValueAtTime(0.3, now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
    const filter = ctx.createBiquadFilter(); filter.type = 'lowpass'; filter.frequency.value = 2000;
    osc.connect(filter); filter.connect(gain); gain.connect(masterGain);
    track(osc);
    osc.start(now); osc.stop(now + 0.1);
  }
  function playReveal() {
    if (sfxCache.reveal) { playSFXBuffer('reveal'); return; }
    if (!ctx || muted) return; ensureContext(); const now = ctx.currentTime;
    const osc = ctx.createOscillator(); osc.type = 'sine';
    osc.frequency.setValueAtTime(440, now); osc.frequency.exponentialRampToValueAtTime(1320, now + 0.2);
    const osc2 = ctx.createOscillator(); osc2.type = 'triangle';
    osc2.frequency.setValueAtTime(660, now); osc2.frequency.exponentialRampToValueAtTime(1760, now + 0.2);
    const gain = ctx.createGain(); gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.3, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.4);
    osc.connect(gain); osc2.connect(gain); gain.connect(masterGain);
    track(osc); track(osc2);
    osc.start(now); osc.stop(now + 0.4); osc2.start(now); osc2.stop(now + 0.4);
  }
  function playDrumroll() {
    if (sfxCache.drumroll) { playSFXBuffer('drumroll'); return; }
    if (!ctx || muted) return; ensureContext(); const now = ctx.currentTime;
    const rollCount = 12;
    for (let i = 0; i < rollCount; i++) {
      const t = now + i * 0.06;
      const buffer = ctx.createBuffer(1, 2400, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let j = 0; j < 2400; j++) { data[j] = (Math.random() * 2 - 1) * 0.5; }
      const src = ctx.createBufferSource(); src.buffer = buffer;
      const filter = ctx.createBiquadFilter(); filter.type = 'lowpass'; filter.frequency.value = 200;
      const gain = ctx.createGain(); gain.gain.setValueAtTime(0.3, t);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.05);
      src.connect(filter); filter.connect(gain); gain.connect(masterGain);
      track(src);
      src.start(t); src.stop(t + 0.06);
    }
  }
  function playCrowdCheer() {
    if (sfxCache.cheer) { playSFXBuffer('cheer'); return; }
    if (!ctx || muted) return; ensureContext(); const now = ctx.currentTime;
    const duration = 3; const bufferSize = ctx.sampleRate * duration;
    const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < bufferSize; i++) {
      const t = i / ctx.sampleRate;
      const envelope = Math.min(1, t / 0.3) * Math.exp(-t * 0.3);
      data[i] = (Math.random() * 2 - 1) * envelope * 0.3;
    }
    const source = ctx.createBufferSource(); source.buffer = buffer;
    const filter1 = ctx.createBiquadFilter(); filter1.type = 'bandpass'; filter1.frequency.value = 1000; filter1.Q.value = 0.5;
    const filter2 = ctx.createBiquadFilter(); filter2.type = 'highpass'; filter2.frequency.value = 300;
    const gain = ctx.createGain(); gain.gain.value = 0.5;
    source.connect(filter1); filter1.connect(filter2); filter2.connect(gain); gain.connect(masterGain);
    track(source);
    source.start(now);
  }
  function startAmbience() {
    if (!ctx || ambienceNodes.length) return;
    ensureContext();
    try {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = 20;
      const gain = ctx.createGain();
      gain.gain.value = 0.001;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start();
      ambienceNodes = [osc, gain];
    } catch(e) {}
  }
  function toggleMute() {
    muted = !muted;
    setVolume(muted ? 0 : (_lastVol || 80));
    const bgAudio = window._bgAudio;
    if (bgAudio) { bgAudio.muted = muted; }
    if (muted && window.speechSynthesis) { window.speechSynthesis.cancel(); }
    return muted;
  }
  var _lastVol = (window.WC_CONFIG && window.WC_CONFIG.bgMusicVol) || 80;
  function setVolume(level) {
    _lastVol = Math.max(0, Math.min(100, level));
    var normalized = (_lastVol / 100) * 0.4;
    if (masterGain) {
      if (window.gsap) { window.gsap.to(masterGain.gain, { value: normalized, duration: 0.15, ease: 'power2.out' }); }
      else { masterGain.gain.value = normalized; }
    }
    const bgAudio = window._bgAudio;
    if (bgAudio) { bgAudio.volume = (_lastVol / 100) * 0.10; }
    muted = level <= 0;
    if (window._volumeUpdate) window._volumeUpdate(_lastVol, muted);
    return _lastVol;
  }
  function getVolume() { return muted ? 0 : _lastVol; }
  function resume() { ensureContext(); }
  function restartMusic() { musicHowl = null; window._bgAudio = null; startMusic(); }
  function initSFX(cfg) {
    const map = { whoosh:'whoosh', heartbeat:'heartbeat', victory:'victory', tick:'tick', reveal:'reveal', drumroll:'drumroll', cheer:'cheer' };
    Object.entries(map).forEach(([name, key]) => {
      const url = cfg[`sfx_${name}_url`];
      const vol = (parseFloat(cfg[`sfx_${name}_vol`]) || 100) / 100;
      if (url) loadSFX(key, url, vol);
    });
  }
  return { init, resume, restartMusic, initSFX, stopAll, playWhoosh, playHeartbeat, playVictory, playTick, playReveal, playDrumroll, playCrowdCheer, startAmbience, startMusic, toggleMute, setVolume, getVolume, get isMuted() { return muted; }, get isInitialized() { return initialized; } };
})();

// =========================================================
// particles.js
// =========================================================
const particles = (() => {
  const canvas = document.getElementById('particle-canvas');
  const ctx2d = canvas ? canvas.getContext('2d') : null;
  let particlesArr = [], animationId = null, mouseX = 0, mouseY = 0, dpr = window.devicePixelRatio || 1;
  function resizeCanvas() {
    if (!canvas || !ctx2d) return;
    canvas.width = window.innerWidth * dpr; canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px'; canvas.style.height = window.innerHeight + 'px';
    ctx2d.scale(dpr, dpr);
  }
  function createParticle() {
    return { x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight,
      vx: (Math.random() - 0.5) * 0.3, vy: -Math.random() * 0.4 - 0.05,
      size: Math.random() * 1.5 + 0.3, baseOpacity: Math.random() * 0.4 + 0.1, opacity: 0,
      color: Math.random() > 0.7 ? '#F9BBC4' : '#ffffff', twinkle: Math.random() * Math.PI * 2,
      twinkleSpeed: 0.02 + Math.random() * 0.03, depth: Math.random()
    };
  }
  function initParticles() {
    if (!canvas || !ctx2d) return; resizeCanvas();
    window.addEventListener('resize', () => { dpr = window.devicePixelRatio || 1; resizeCanvas(); });
    particlesArr = Array.from({ length: 100 }, () => createParticle());
    window.addEventListener('mousemove', (e) => {
      mouseX = (e.clientX / window.innerWidth - 0.5) * 2; mouseY = (e.clientY / window.innerHeight - 0.5) * 2;
    });
    animate();
  }
  function animate() {
    if (!ctx2d) return; ctx2d.clearRect(0, 0, window.innerWidth, window.innerHeight);
    particlesArr.forEach((p) => {
      p.x += p.vx + mouseX * 0.3 * p.depth; p.y += p.vy + mouseY * 0.2 * p.depth; p.twinkle += p.twinkleSpeed;
      if (p.y < -10) { p.y = window.innerHeight + 10; p.x = Math.random() * window.innerWidth; }
      if (p.x < -10) p.x = window.innerWidth + 10; if (p.x > window.innerWidth + 10) p.x = -10;
      p.opacity = p.baseOpacity * (0.4 + 0.6 * Math.abs(Math.sin(p.twinkle)));
      ctx2d.beginPath(); ctx2d.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx2d.fillStyle = p.color; ctx2d.globalAlpha = p.opacity; ctx2d.fill();
      if (p.color === '#F9BBC4' && p.opacity > 0.2) {
        ctx2d.beginPath(); ctx2d.arc(p.x, p.y, p.size * 3, 0, Math.PI * 2);
        const gradient = ctx2d.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * 3);
        gradient.addColorStop(0, `rgba(255, 215, 0, ${p.opacity * 0.3})`); gradient.addColorStop(1, 'rgba(255, 215, 0, 0)');
        ctx2d.fillStyle = gradient; ctx2d.fill();
      }
    });
    ctx2d.globalAlpha = 1; animationId = requestAnimationFrame(animate);
  }
  function burst(x = 0.5, y = 0.5, count = 50) {
    if (!window.confetti) return;
    window.confetti({ particleCount: count, spread: 70, startVelocity: 30, origin: { x, y }, colors: ['#F9BBC4', '#ffa500', '#ffffff', '#ff6b6b', '#cd7f32'], scalar: 0.8, ticks: 150 });
  }
  function fireworks(duration = 3000) {
    const fwCanvas = document.getElementById('fireworksCanvas');
    if (!fwCanvas) return;
    const fwCtx = fwCanvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    let fwArr = [];
    let fwParticlesArr = [];
    let fwReqId = null;
    let active = true;

    function resizeFW() {
      fwCanvas.width = window.innerWidth * dpr;
      fwCanvas.height = window.innerHeight * dpr;
      fwCanvas.style.width = window.innerWidth + 'px';
      fwCanvas.style.height = window.innerHeight + 'px';
      fwCtx.setTransform(1, 0, 0, 1, 0, 0);
      fwCtx.scale(dpr, dpr);
    }
    resizeFW();
    const onResize = () => resizeFW();
    window.addEventListener('resize', onResize);

    class Firework {
      constructor(x, targetY) {
        this.x = x;
        this.y = window.innerHeight;
        this.targetY = targetY;
        this.hue = Math.random() * 360;
        this.brightness = 50 + Math.random() * 50;
        this.element = { x: this.x, y: this.y };
        this.animate();
      }
      animate() {
        gsap.to(this.element, {
          y: this.targetY,
          duration: 1.5 + Math.random(),
          ease: 'power2.out',
          onUpdate: () => {
            this.y = this.element.y;
            this.draw();
          },
          onComplete: () => {
            explode(this.x, this.y, this.hue);
            fwArr = fwArr.filter((f) => f !== this);
          }
        });
      }
      draw() {
        fwCtx.beginPath();
        fwCtx.arc(this.x, this.y, 3, 0, 2 * Math.PI);
        fwCtx.fillStyle = `hsl(${this.hue}, 100%, ${this.brightness}%)`;
        fwCtx.fill();
      }
    }

    class FwParticle {
      constructor(x, y, hue) {
        this.x = x;
        this.y = y;
        this.hue = hue;
        this.brightness = 50 + Math.random() * 50;
        this.angle = Math.random() * Math.PI * 2;
        this.speed = 2 + Math.random() * 5;
        this.gravity = 0.5;
        this.element = { x: this.x, y: this.y, opacity: 1 };
        this.animate();
      }
      animate() {
        gsap.to(this.element, {
          x: this.x + Math.cos(this.angle) * this.speed * 50,
          y: this.y + Math.sin(this.angle) * this.speed * 50 + this.gravity * 50,
          opacity: 0,
          duration: 1 + Math.random() * 0.5,
          ease: 'power1.out',
          onUpdate: () => {
            this.x = this.element.x;
            this.y = this.element.y;
            this.draw();
          },
          onComplete: () => {
            fwParticlesArr = fwParticlesArr.filter((p) => p !== this);
          }
        });
      }
      draw() {
        fwCtx.save();
        fwCtx.globalAlpha = this.element.opacity;
        fwCtx.beginPath();
        fwCtx.arc(this.x, this.y, 2, 0, 2 * Math.PI);
        fwCtx.fillStyle = `hsl(${this.hue}, 100%, ${this.brightness}%)`;
        fwCtx.fill();
        fwCtx.restore();
      }
    }

    function createFirework(x, y) {
      fwArr.push(new Firework(x, y));
    }

    function explode(x, y, hue) {
      for (let i = 0; i < 50; i++) {
        fwParticlesArr.push(new FwParticle(x, y, hue));
      }
    }

    function animateFW() {
      if (!active && fwArr.length === 0 && fwParticlesArr.length === 0) {
        cancelAnimationFrame(fwReqId);
        window.removeEventListener('resize', onResize);
        fwCtx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        return;
      }
      fwCtx.fillStyle = 'rgba(0, 0, 0, 0.12)';
      fwCtx.fillRect(0, 0, window.innerWidth, window.innerHeight);
      fwReqId = requestAnimationFrame(animateFW);
    }

    const startTime = Date.now();
    const interval = setInterval(() => {
      if (Date.now() - startTime > duration) {
        clearInterval(interval);
        active = false;
        return;
      }
      createFirework(
        Math.random() * window.innerWidth,
        Math.random() * window.innerHeight * 0.5
      );
    }, 600);

    createFirework(Math.random() * window.innerWidth, Math.random() * window.innerHeight * 0.5);
    animateFW();
  }
  function confettiRain(duration = 5000) {
    const body = document.body;
    const end = Date.now() + duration;
    const colors = ['#F9BBC4', '#ffa500', '#ffffff', '#cd7f32', '#c0c0c0', '#e5e4e2'];
    const rain = () => {
      if (Date.now() > end) return;
      const frag = document.createDocumentFragment();
      const items = [];
      for (let i = 0; i < 3; i++) {
        const el = document.createElement('div');
        const size = 3 + Math.random() * 4;
        const bg = colors[~~(Math.random() * colors.length)];
        el.style.cssText = `position:fixed;width:${size}px;height:${size*1.5}px;background:${bg};pointer-events:none;z-index:99999;border-radius:1px;will-change:transform,opacity;left:${Math.random() * window.innerWidth}px;top:-10px`;
        frag.appendChild(el);
        items.push(el);
      }
      body.appendChild(frag);
      for (let i = 0; i < items.length; i++) {
        const el = items[i];
        gsap.to(el, {
          y: window.innerHeight + 20, x: (Math.random() - 0.5) * 150,
          rotation: Math.random() * 360, opacity: 0.7,
          duration: 3 + Math.random() * 2, ease: 'none',
          force3D: true,
          onComplete: () => el.remove()
        });
      }
      setTimeout(rain, 120 + Math.random() * 120);
    };
    rain();
  }
  function stop() { if (animationId) { cancelAnimationFrame(animationId); animationId = null; } }

  return { init: initParticles, burst, fireworks, confettiRain, stop };
})();

// =========================================================
// animation.js
// =========================================================
function splitTextFallback(element, options = {}) {
  const text = element.textContent; element.innerHTML = ''; const chars = []; const words = [];
  text.split(' ').forEach((word, wi) => {
    const wordSpan = document.createElement('span'); wordSpan.style.display = 'inline-block'; wordSpan.style.whiteSpace = 'nowrap';
    word.split('').forEach((char) => {
      const span = document.createElement('span'); span.style.display = 'inline-block';
      span.textContent = char === ' ' ? '\u00A0' : char; wordSpan.appendChild(span); chars.push(span);
    });
    element.appendChild(wordSpan);
    if (wi < text.split(' ').length - 1) { element.appendChild(document.createTextNode(' ')); }
    words.push(wordSpan);
  });
  return { chars, words, lines: [element] };
}
function safeSplitText(element, options) {
  if (window.SplitText) { try { return new SplitText(element, options); } catch (e) { return splitTextFallback(element, options); } }
  return splitTextFallback(element, options);
}
function createParticipantCards(participants) {
  const wall = document.getElementById('participant-wall'); if (!wall) return;
  participants.forEach((p) => {
    const card = document.createElement('div'); card.className = 'participant-card';
    card.dataset.id = p.id; card.dataset.tier = p.tier; card.dataset.depth = Math.floor(Math.random() * 5);
    card.innerHTML = `<div class="card-glow"></div><div class="card-inner"><div class="card-shimmer"></div><div class="card-top"><div class="card-rating">${p.rating}</div><div class="card-flag">${p.flag}</div></div><div class="card-avatar"><span>${p.firstName[0]}${p.lastName[0]}</span></div><div class="card-name">${p.name}</div><div class="card-club">${p.club}</div></div>`;
    wall.appendChild(card);
  });
}
let parallaxHandlers = [], parallaxActive = false;
function initParallax() {
  const cards = document.querySelectorAll('.participant-card'); parallaxHandlers = [];
  cards.forEach((card) => {
    const inner = card.querySelector('.card-inner'); if (!inner) return;
    const depth = parseInt(card.dataset.depth) || 0; const factor = 0.3 + depth * 0.15;
    const setX = gsap.quickTo(inner, 'rotationY', { duration: 0.5, ease: 'power2.out' });
    const setY = gsap.quickTo(inner, 'rotationX', { duration: 0.5, ease: 'power2.out' });
    const setZ = gsap.quickTo(inner, 'translateZ', { duration: 0.5, ease: 'power2.out' });
    parallaxHandlers.push({ setX, setY, setZ, factor });
  });
  if (!parallaxActive) { parallaxActive = true; window.addEventListener('mousemove', handleParallax); }
}
function handleParallax(e) {
  const mx = (e.clientX / window.innerWidth - 0.5) * 2; const my = (e.clientY / window.innerHeight - 0.5) * 2;
  parallaxHandlers.forEach(({ setX, setY, setZ, factor }) => { setX(mx * 8 * factor); setY(-my * 8 * factor); setZ(factor * 10); });
}
function disableParallax() { parallaxActive = false; window.removeEventListener('mousemove', handleParallax); }
function startFloating() {
  const cards = document.querySelectorAll('.participant-card:not(.winner) .card-inner');
  cards.forEach((card) => { gsap.to(card, { y: '+=6', duration: 1.5 + Math.random() * 1.5, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: Math.random() * 2 }); });
}
function startShimmer() {
  const shimmers = document.querySelectorAll('.participant-card:not(.winner) .card-shimmer');
  shimmers.forEach((shimmer) => { gsap.to(shimmer, { left: '150%', duration: 2 + Math.random() * 2, repeat: -1, ease: 'power2.inOut', delay: Math.random() * 4, repeatDelay: Math.random() * 3 }); });
}
function showScene(sceneName) {
  const scenes = document.querySelectorAll('.scene'); scenes.forEach((s) => s.classList.remove('active'));
  const target = document.getElementById(`scene-${sceneName}`); if (target) { target.classList.add('active'); }
}

function heroAnimation(els) {
  const tl = gsap.timeline();
  const titleLines = els.heroTitle.querySelectorAll('.title-line');
  titleLines.forEach((line) => { const split = safeSplitText(line, { type: 'chars' }); line._splitChars = split.chars; });
  tl.fromTo(els.heroEyebrow, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' })
    .fromTo(titleLines[0]._splitChars, { y: 120, opacity: 0, rotationX: -90 }, { y: 0, opacity: 1, rotationX: 0, stagger: 0.04, duration: 1, ease: 'power4.out' }, '-=0.3')
    .fromTo(titleLines[1]._splitChars, { y: 120, opacity: 0, rotationX: -90 }, { y: 0, opacity: 1, rotationX: 0, stagger: 0.04, duration: 1, ease: 'power4.out' }, '-=0.7')
    .fromTo(els.heroSubtitle, { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, '-=0.4')
    .to(els.heroHint, { opacity: 1, duration: 0.5, ease: 'power2.out' });

  // Auto Countdown
  const ceremonyCountdown = (window.WC_CONFIG && window.WC_CONFIG.ceremonyCountdown) || 15;
  let countVal = { val: ceremonyCountdown };
  tl.to(countVal, {
    val: 0, duration: ceremonyCountdown, ease: "none",
    onStart: () => {},
    onUpdate: () => {
      const currentCount = Math.ceil(countVal.val);
      if (els.heroHint.dataset.lastCount !== String(currentCount)) {
        els.heroHint.dataset.lastCount = String(currentCount);
        els.heroHint.querySelector('#hero-countdown-text').textContent = _cfg('countdownMessage', 'Ceremony starts in %ds').replace('%d', currentCount);
        if (currentCount <= 5 && currentCount > 0) sound.playTick(false);
      }
    }
  });

  // Animate hint out and proceed to 3-2-1-GO
  tl.to(els.heroHint, { opacity: 0, y: -20, duration: 0.3, ease: 'power2.in' })
    .to(els.heroSubtitle, { opacity: 0, y: -20, duration: 0.3, ease: 'power2.in' }, '<')
    .to(els.countdownWrapper, { opacity: 1, scale: 1, duration: 0.5, ease: 'back.out(2)' })
    .call(() => { els.countdownNumber.textContent = '3'; sound.playTick(false); })
    .fromTo(els.countdownNumber, { scale: 2, opacity: 0, filter: 'blur(10px)' }, { scale: 1, opacity: 1, filter: 'blur(0px)', duration: 0.5, ease: 'power3.out' })
    .to(els.countdownNumber, { scale: 0.7, opacity: 0, filter: 'blur(5px)', duration: 0.4, ease: 'power2.in', delay: 0.3 })
    .call(() => { els.countdownNumber.textContent = '2'; sound.playTick(false); })
    .fromTo(els.countdownNumber, { scale: 2, opacity: 0, filter: 'blur(10px)' }, { scale: 1, opacity: 1, filter: 'blur(0px)', duration: 0.5, ease: 'power3.out' })
    .to(els.countdownNumber, { scale: 0.7, opacity: 0, filter: 'blur(5px)', duration: 0.4, ease: 'power2.in', delay: 0.3 })
    .call(() => { els.countdownNumber.textContent = '1'; sound.playTick(false); })
    .fromTo(els.countdownNumber, { scale: 2, opacity: 0, filter: 'blur(10px)' }, { scale: 1, opacity: 1, filter: 'blur(0px)', duration: 0.5, ease: 'power3.out' })
    .to(els.countdownNumber, { scale: 0.7, opacity: 0, filter: 'blur(5px)', duration: 0.4, ease: 'power2.in', delay: 0.3 })
    .call(() => { els.countdownNumber.textContent = 'GO'; sound.playWhoosh(1, 1.5); })
    .fromTo(els.countdownNumber, { scale: 0.5, opacity: 0 }, { scale: 3, opacity: 1, duration: 0.4, ease: 'power3.out' })
    .to(els.countdownNumber, { opacity: 0, scale: 5, filter: 'blur(20px)', duration: 0.5, ease: 'power2.in' })
    .to(els.heroContent, { opacity: 0, scale: 1.1, filter: 'blur(10px)', duration: 0.6, ease: 'power2.inOut' }, '-=0.3')
    .call(() => { showScene('opening'); });
  return tl;
}
function openingAnimation(els) {
  const tl = gsap.timeline();
  tl.set(els.openingStats, { opacity: 1 })
    .fromTo(els.openingEyebrow, { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' })
    .call(() => sound.playWhoosh(0.3))
    .to(els.openingStats[0], { opacity: 1, y: 0, duration: 0.6, ease: 'back.out(1.5)' })
    .call(() => sound.playTick(true))
    .to(els.openingStats[0].querySelector('.stat-number'), { textContent: demoData.totalParticipants, duration: 1.5, ease: 'power2.out', snap: { textContent: 1 } }, '<')
    .call(() => sound.playWhoosh(0.3))
    .to(els.openingStats[1], { opacity: 1, y: 0, duration: 0.6, ease: 'back.out(1.5)' }, '-=0.3')
    .call(() => sound.playTick(true))
    .to(els.openingStats[1].querySelector('.stat-number'), { textContent: demoData.totalCorrectGuesses, duration: 1, ease: 'power2.out', snap: { textContent: 1 } }, '<')
    .call(() => sound.playWhoosh(0.3))
    .to(els.openingStats[2], { opacity: 1, y: 0, duration: 0.6, ease: 'back.out(1.5)' }, '-=0.3')
    .call(() => sound.playTick(true))
    .to(els.openingStats[2].querySelector('.stat-number'), { textContent: demoData.winners.thirdPrize.length, duration: 1, ease: 'power2.out', snap: { textContent: 1 } }, '<')
    .call(() => sound.playWhoosh(0.3))
    .to(els.openingStats[3], { opacity: 1, y: 0, duration: 0.6, ease: 'back.out(1.5)' }, '-=0.3')
    .call(() => sound.playTick(true))
    .to(els.openingStats[3].querySelector('.stat-number'), { textContent: demoData.winners.runnerUp.length, duration: 0.8, ease: 'power2.out', snap: { textContent: 1 } }, '<')
    .call(() => sound.playWhoosh(0.5))
    .to(els.openingStats[4], { opacity: 1, y: 0, duration: 0.8, ease: 'back.out(1.5)' }, '-=0.3')
    .call(() => sound.playVictory())
    .to(els.openingStats[4].querySelector('.stat-number'), { textContent: demoData.winners.grandPrize.length, duration: 0.5, ease: 'power2.out', snap: { textContent: 1 } }, '<')
    .from(els.openingTagline, { opacity: 0, y: 30, duration: 0.8, ease: 'power3.out' }, '+=0.3')
    .to(els.openingContent, { opacity: 0, scale: 0.95, filter: 'blur(8px)', duration: 0.6, ease: 'power2.inOut', delay: 1 })
    .call(() => { showScene('ceremony'); });
  return tl;
}
// =========================================================
// Wave Entry System
// =========================================================
const WAVE_SIZE = 20;
function getCardNaturalPosition(card) {
  const rect = card.getBoundingClientRect();
  return { left: rect.left, top: rect.top, width: rect.width, height: rect.height };
}

function performWaveEntry(waveCards, entranceSide, waveIndex, totalWaves) {
  const tl = gsap.timeline();
  const isLastWave = waveIndex >= totalWaves - 1;

  // Spotlight sweep
  tl.call(() => {
      const sweep = document.getElementById('spotlight-sweep');
      if (sweep) {
        const fromLeft = entranceSide === 'left';
        gsap.set(sweep, { left: fromLeft ? '-50%' : '150%', opacity: 1 });
        gsap.to(sweep, { left: fromLeft ? '150%' : '-50%', opacity: 0, duration: 1.2, ease: 'power2.inOut' });
      }
    })

    // Animate cards in
    .call(() => {
      waveCards.forEach((card, i) => {
        if (!card) return;
        card.classList.remove('wave-hidden');
        card.classList.add('wave-entering');

        const staggerDelay = i * 0.08;
        const entranceOffset = window.innerWidth * 0.6;

        let fromVars, toVars;
        if (entranceSide === 'left') {
          fromVars = { x: -entranceOffset, y: -40 - Math.random() * 40, opacity: 0, scale: 1.8, rotationY: -25, filter: 'blur(6px)' };
        } else if (entranceSide === 'right') {
          fromVars = { x: entranceOffset, y: -40 - Math.random() * 40, opacity: 0, scale: 1.8, rotationY: 25, filter: 'blur(6px)' };
        } else {
          fromVars = { y: -entranceOffset * 0.5, x: (Math.random() - 0.5) * 100, opacity: 0, scale: 1.5, rotationX: -20, filter: 'blur(6px)' };
        }
        toVars = { x: 0, y: 0, opacity: 1, scale: 1, rotationY: 0, rotationX: 0, filter: 'blur(0px)', duration: 0.7, ease: 'power3.out', delay: staggerDelay };

        gsap.fromTo(card, fromVars, toVars);
      });
    })
    .to({}, { duration: 0.4 })
    .call(() => {
      waveCards.forEach(card => { if (card) card.classList.remove('wave-entering'); });
      if (isLastWave) {
        sound.playWhoosh(0.8, 0.6);
        startFloating();
        startShimmer();
        initParallax();
      }
    });
  return tl;
}

function wallAnimation(els) {
  const tl = gsap.timeline();
  // Sort participants by rating descending for dramatic high-to-low reveal
  const sortedParticipants = [...demoData.participants].sort((a, b) => b.rating - a.rating);
  const cards = document.querySelectorAll('.participant-card');
  const cardMap = {};
  cards.forEach(c => { cardMap[c.dataset.id] = c; });

  // Hide all cards initially
  cards.forEach(c => c.classList.add('wave-hidden'));

  const waves = [];
  for (let i = 0; i < sortedParticipants.length; i += WAVE_SIZE) {
    waves.push(sortedParticipants.slice(i, i + WAVE_SIZE));
  }

  const entrances = ['center', 'left', 'right'];
  const waveLabels = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII','XIII','XIV','XV','XVI'];

  tl.from(els.wallPanel, { opacity: 0, duration: 0.6, ease: 'power2.out' })
    .from(els.wallPanel.querySelector('.panel-header'), { y: -20, opacity: 0, duration: 0.6, ease: 'power3.out' }, '<');

  waves.forEach((wave, wi) => {
    const entranceSide = entrances[wi % entrances.length];
    const waveCards = wave.map(p => cardMap[p.id]).filter(Boolean);
    tl.add(performWaveEntry(waveCards, entranceSide, wi, waves.length));

    // Brief update to counters
    tl.call(() => {
      const revealed = Math.min((wi + 1) * WAVE_SIZE, demoData.totalParticipants);
      gsap.to(els.remainingCount, { textContent: demoData.totalParticipants - revealed, duration: 0.3, snap: { textContent: 1 } });
    });
  });

  tl.to({}, { duration: 0.5 });
  return tl;
}

// =========================================================
// Camera Effects
// =========================================================
function cameraShake(intensity = 4, repeats = 3) {
  const app = document.getElementById('app');
  gsap.to(app, {
    x: () => (Math.random() - 0.5) * intensity * 2,
    y: () => (Math.random() - 0.5) * intensity * 2,
    duration: 0.06,
    repeat: repeats,
    yoyo: true,
    ease: 'power1.inOut',
    onComplete: () => { gsap.set(app, { x: 0, y: 0 }); }
  });
}
function cameraZoom(scale = 1.03, brightness = 1.1) {
  const app = document.getElementById('app');
  gsap.to(app, { scale, filter: `brightness(${brightness})`, duration: 1.5, ease: 'power2.out' });
}
function cameraReset() {
  const app = document.getElementById('app');
  gsap.to(app, { scale: 1, filter: 'brightness(1)', x: 0, y: 0, duration: 0.8, ease: 'power2.out' });
}

// =========================================================
// Typewriter & Popup Animations
// =========================================================
function typewriterAnimation(element, text) {
  const tl = gsap.timeline();
  element.textContent = '';
  const chars = text.split('');
  chars.forEach((char, i) => {
    const span = document.createElement('span');
    span.className = 'typewriter-char';
    span.textContent = char === ' ' ? '\u00A0' : char;
    element.appendChild(span);
    tl.fromTo(span,
      { opacity: 0, scale: 1.4, filter: 'blur(4px)' },
      { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 0.08, ease: 'power2.out' },
      i * 0.04
    );
  });
  return tl;
}

const POPUP_HOLD_DURATION = (window.WC_CONFIG && window.WC_CONFIG.popupHoldDuration) || 30;

// =========================================================
// Text-to-speech for name announcements
// =========================================================
let synth = null;
function speak(text) {
  try {
    if (!synth) synth = window.speechSynthesis;
    if (!synth) return;
    if (sound && sound.isMuted) return;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.85;
    utterance.pitch = 1.1;
    utterance.volume = 0.6;
    synth.speak(utterance);
  } catch(e) {}
}

// =========================================================
// Ember reveal — fire drop ashes at center of a skeleton card
// =========================================================
function emberRevealCard(cardEl, winner, tier) {
  const tl = gsap.timeline();
  const zone = cardEl.querySelector('.skel-ember-zone');
  const inner = cardEl.querySelector('.skel-inner');
  const rect = cardEl.getBoundingClientRect();
  const cx = rect.width / 2;
  const cy = rect.height / 2;

  // Create ember particles that rain down like fire ashes
  const emberCount = 30;
  const embers = [];
  for (let i = 0; i < emberCount; i++) {
    const ember = document.createElement('div');
    ember.className = 'ember-particle';
    const size = 2 + Math.random() * 4;
    const angle = (Math.PI * 2 / emberCount) * i + (Math.random() - 0.5) * 0.3;
    const dist = 6 + Math.random() * 20;
    const startX = cx + Math.cos(angle) * dist;
    const startY = cy + Math.sin(angle) * dist;
    ember.style.cssText = `width:${size}px;height:${size}px;left:${startX}px;top:${startY}px;background:radial-gradient(circle, #F9BBC4, #ff6b00, transparent);opacity:0;`;
    zone.appendChild(ember);
    embers.push(ember);

    // Each ember bursts outward then falls
    const burstAngle = Math.random() * Math.PI * 2;
    const burstDist = 15 + Math.random() * 35;
    const fallY = 20 + Math.random() * 40;
    gsap.set(ember, { opacity: 0, scale: 0.3 + Math.random() * 0.5 });
    gsap.to(ember, {
      opacity: 1,
      scale: 1 + Math.random(),
      duration: 0.15,
      ease: 'power2.out',
      delay: Math.random() * 0.15
    });
    gsap.to(ember, {
      x: Math.cos(burstAngle) * burstDist,
      y: fallY,
      opacity: 0,
      scale: 0.2,
      duration: 1.2 + Math.random() * 0.6,
      ease: 'power2.in',
      delay: 0.2 + Math.random() * 0.3,
      onComplete: () => ember.remove()
    });
  }

  // Flash the card after embers start falling
  tl.call(() => {
      sound.playReveal();
      cardEl.classList.add('revealed');
      speak(winner.firstName + ' ' + winner.lastName);
    })
    // Populate content with slow reveal
    .call(() => {
      inner.innerHTML = `
        <div class="skel-top">
          <div class="skel-id">${winner.id.length > 4 ? '#...' + winner.id.slice(-4) : '#' + winner.id}</div>
        </div>
        <div class="skel-avatar">${winner.firstName[0]}${winner.lastName[0]}</div>
        <div class="skel-name">${winner.name}</div>
        <div class="skel-club">${winner.club}</div>
      `;
      gsap.fromTo(inner, { opacity: 0, filter: 'blur(8px)' }, { opacity: 1, filter: 'blur(0px)', duration: 1.0, ease: 'power3.out' });
      // Glow flash
      gsap.fromTo(cardEl, { boxShadow: '0 0 30px rgba(255,215,0,0.6)' }, { boxShadow: '0 0 0px rgba(255,215,0,0)', duration: 1.2, ease: 'power2.out' });
    })
    .to({}, { duration: 0.6 });
  return tl;
}

function popupRevealAnimation(els, { winners, popupId, titleId, boardId, hintId, titleText, tierClass, cardTier }) {
  const tl = gsap.timeline();
  const wall = document.getElementById('participant-wall');
  const popup = document.getElementById(popupId);
  const board = document.getElementById(boardId);
  const titleEl = document.getElementById(titleId);
  const hintEl = document.getElementById(hintId);
  const isThird = tierClass === 'bronze-title';

  board.innerHTML = '';
  board.scrollTop = 0;

  // Show popup
  tl.call(() => { popup.classList.add('visible'); sound.playWhoosh(0.5, 0.8); board.scrollTop = 0; })
    // Typewriter title (starts immediately)
    .add(typewriterAnimation(titleEl, titleText), '+=0.1')
    .to(hintEl, { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' }, '-=0.1')
    .to({}, { duration: 0.15 });

  // Create skeleton cards in the popup board (hidden initially)
  const skeletonCards = [];
  winners.forEach((winner, i) => {
    const skel = document.createElement('div');
    skel.className = 'card-skeleton';
    skel.dataset.id = winner.id;
    skel.style.opacity = '0';
    skel.innerHTML = `<div class="skel-glow"></div><div class="skel-ember-zone"></div><div class="skel-inner"></div>`;
    board.appendChild(skel);
    skeletonCards.push({ el: skel, winner });
  });

  // Animate all skeleton cards into view
  tl.call(() => {
      skeletonCards.forEach(({ el }, i) => {
        gsap.set(el, { opacity: 0, scale: 0.5 });
        gsap.to(el, {
          opacity: 1, scale: 1,
          duration: 0.5 + Math.random() * 0.3,
          ease: 'back.out(1.4)',
          delay: 0.04 * i,
          onComplete: () => { el.style.transform = ''; el.style.opacity = ''; }
        });
      });
      sound.playWhoosh(0.8, 0.6);
    })
    .to({}, { duration: 0.6 });

  // Reveal each card one by one with ember animation + speech
  let revealedCount = 0;
  skeletonCards.forEach(({ el, winner }) => {
    const nameLen = (winner.firstName + ' ' + winner.lastName).length;
    const speechMsPerChar = (window.WC_CONFIG && window.WC_CONFIG.nameSpeechSpeed) || 140;
    const cardRevealSpeed = (window.WC_CONFIG && window.WC_CONFIG.cardRevealSpeed) || 100;
    const speechTime = Math.max(800, nameLen * speechMsPerChar + 600);
    const revealDelay = (speechTime / 1000) * (100 / cardRevealSpeed);
    tl.add(emberRevealCard(el, winner, cardTier))
      .to({}, { duration: revealDelay })
      .call(() => {
        revealedCount++;
        const total = demoData.totalParticipants;
        const thirdCount = demoData.winners.thirdPrize.length;
        const remaining = total - revealedCount - (isThird ? 0 : thirdCount);
        const wCount = revealedCount + (isThird ? 0 : thirdCount);
        gsap.to(els.remainingCount, { textContent: remaining, duration: 0.3, snap: { textContent: 1 } });
        gsap.to(els.winnersCount, { textContent: wCount, duration: 0.3, snap: { textContent: 1 } });
      });
  });

  // All revealed — hold for 30s
  tl.call(() => {
      const burstCount = isThird ? 20 : 30;
      particles.burst(0.5, 0.7, burstCount);
      cameraShake(isThird ? 3 : 5, 2);
      sound.playTick(true);
      hintEl.textContent = _cfg('popupHoldMessage', 'Showing all %d winners — screen closes in %ds').replace('%d', winners.length).replace('%ds', POPUP_HOLD_DURATION);
    })
    .to(hintEl, { opacity: 0.7, duration: 0.3 }, '-=0.2')
    .to({}, { duration: POPUP_HOLD_DURATION, ease: 'none',
      onUpdate: function() {
        const elapsed = this.duration() * this.progress();
        const remaining = Math.max(0, Math.ceil(POPUP_HOLD_DURATION - elapsed));
        hintEl.textContent = _cfg('popupHoldMessage', 'Showing all %d winners — screen closes in %ds').replace('%d', winners.length).replace('%ds', remaining);
      }
    })
    .to(hintEl, { opacity: 0, duration: 0.3 })
    .to(popup, { opacity: 0, duration: 0.5, ease: 'power2.inOut' })
    .call(() => { popup.classList.remove('visible'); popup.style.opacity = ''; try { window.speechSynthesis && window.speechSynthesis.cancel(); } catch(e) {} });
  return tl;
}

// Store champion card globally since we remove it from the wall
let _championCard = null;
function thirdPrizeAnimation(els) {
  // Remove all winner cards from wall so they don't show behind glass popup
  const wall = document.getElementById('participant-wall');
  const champ = demoData.winners.grandPrize[0];
  _championCard = champ ? wall.querySelector(`[data-id="${champ.id}"]`) : null;
  demoData.winners.thirdPrize.forEach(w => {
    const c = wall.querySelector(`[data-id="${w.id}"]`);
    if (c) c.remove();
  });
  demoData.winners.runnerUp.forEach(w => {
    const c = wall.querySelector(`[data-id="${w.id}"]`);
    if (c) c.remove();
  });
  if (_championCard) _championCard.remove();

  return popupRevealAnimation(els, {
    winners: demoData.winners.thirdPrize,
    popupId: 'third-popup',
    titleId: 'third-popup-title',
    boardId: 'third-popup-board',
    hintId: 'third-popup-hint',
    titleText: _cfg('thirdPopupTitle', 'THIRD PRIZE WINNERS'),
    tierClass: 'bronze-title',
    cardTier: 'tier-third'
  });
}
function runnerUpAnimation(els) {
  return popupRevealAnimation(els, {
    winners: demoData.winners.runnerUp,
    popupId: 'runner-popup',
    titleId: 'runner-popup-title',
    boardId: 'runner-popup-board',
    hintId: 'runner-popup-hint',
    titleText: _cfg('runnerPopupTitle', 'RUNNER UPS'),
    tierClass: 'silver-title',
    cardTier: 'tier-runner'
  });
}
function championAnimation(els) {
  const tl = gsap.timeline();
  const winner = demoData.winners.grandPrize[0];
  if (!winner) {
    console.warn('[WCEREMONY] No champion winner found; skipping champion animation.');
    return tl;
  }
  // Build champion card from winner data directly (may not be on the wall)
  var winnerCard = document.createElement('div');
  winnerCard.className = 'participant-card';
  winnerCard.dataset.id = winner.id;
  winnerCard.style.opacity = '0';
  winnerCard.innerHTML = '<div class="card-glow"></div><div class="card-inner"><div class="card-shimmer"></div><div class="card-top"></div><div class="card-avatar"><span>' + winner.firstName[0] + winner.lastName[0] + '</span></div><div class="card-name">' + winner.name + '</div><div class="card-club">' + winner.club + '</div></div>';
  const remainingDivs = document.querySelectorAll('.scene-ceremony > .wall-panel .participant-card');
  tl.call(() => { sound.playWhoosh(1, 1); })
    .to({}, { duration: 0.6 })
    .call(() => {
      els.championPanel.classList.add('active'); disableParallax();
      els.cyclingName.textContent = '?';
      els.cyclingName.classList.add('is-question');
    })
    .to(remainingDivs, { opacity: 0, filter: 'blur(3px)', duration: 1, stagger: 0.005, ease: 'power2.inOut' })
    .to('.wall-panel', { opacity: 0, duration: 1, ease: 'power2.inOut' }, '<')
    .call(() => { sound.playHeartbeat(); gsap.fromTo(els.cyclingName, { scale: 1 }, { scale: 1.3, duration: 0.15, ease: 'power2.out', yoyo: true, repeat: 1 }); }).to({}, { duration: 0.9 })
    .call(() => { sound.playHeartbeat(); gsap.fromTo(els.cyclingName, { scale: 1 }, { scale: 1.35, duration: 0.15, ease: 'power2.out', yoyo: true, repeat: 1 }); }).to({}, { duration: 0.9 })
    .call(() => { sound.playHeartbeat(); gsap.fromTo(els.cyclingName, { scale: 1 }, { scale: 1.4, duration: 0.15, ease: 'power2.out', yoyo: true, repeat: 1 }); }).to({}, { duration: 0.6 })
    .to(els.cyclingDisplay.querySelector('.cycling-label'), { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' })
    .from(els.cyclingDisplay.querySelector('.cycling-label'), { y: 20, duration: 0.6, ease: 'power3.out' }, '<')
    .call(() => { els.cyclingName.classList.remove('is-question'); });

  const otherParticipants = demoData.participants.filter(function(p) { return p.id !== winner.id; });
  var cycleState = { progress: 0 }; var lastIdx = -1; var totalCycles = 60;
  tl.to(cycleState, { progress: 1, duration: 5, ease: 'power2.out', onUpdate: function() {
      var idx = Math.floor(cycleState.progress * totalCycles);
      if (idx !== lastIdx) {
        lastIdx = idx; var isFinal = idx >= totalCycles - 1;
        var name = isFinal ? winner.name : '';
        if (!isFinal && otherParticipants.length > 0) {
          name = otherParticipants[idx % otherParticipants.length].name;
        }
        els.cyclingName.textContent = name || winner.name;
        gsap.fromTo(els.cyclingName, { scale: 1.1, color: isFinal ? '#F9BBC4' : '#ffffff', textShadow: isFinal ? '0 0 30px rgba(255,215,0,0.8)' : '0 0 0px rgba(255,215,0,0)' }, { scale: 1, duration: 0.06, ease: 'power2.out' });
        if (idx % 3 === 0 && !isFinal) { try { sound.playTick(false); } catch(e) {} }
      }
    }
  })
  .call(() => { sound.playDrumroll(); })
  .to(els.cyclingName, { scale: 1.3, color: '#F9BBC4', textShadow: '0 0 40px rgba(255,215,0,0.8)', duration: 0.5, ease: 'back.out(2)' })
  // Immediately: name + fireworks + victory fanfare + champion card + crowd cheer + background restore — all in parallel
  .call(function() {
    particles.fireworks(2000); particles.confettiRain(2500);
    sound.playReveal();
    sound.playVictory();
    els.championCardContainer.appendChild(winnerCard);
    gsap.to(els.championCardContainer, { opacity: 1, duration: 0.3, ease: 'power2.out' });
    gsap.fromTo(winnerCard, { opacity: 0, scale: 0.4 }, { opacity: 1, scale: 1, duration: 0.8, ease: 'back.out(1.7)' });
    gsap.to(els.cyclingDisplay, { opacity: 0, duration: 0.4, ease: 'power2.in' });
    // Name appears immediately
    els.championMeta.innerHTML = `<div style="font-size: 16px; color: var(--color-gold); margin-bottom: 4px;">#${winner.id}</div><div style="font-size: 14px;">Congratulations!</div>`;
    gsap.to(els.championInfo, { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' });
    gsap.from(els.championInfo, { y: 30, duration: 0.6, ease: 'power3.out' }, '<');
    sound.playCrowdCheer();
    // Restore background in parallel
    document.querySelectorAll('.scene-ceremony .participant-card').forEach(c => {
      gsap.to(c, { opacity: 1, filter: 'none', duration: 0.5, ease: 'power2.out' });
    });
    gsap.to('.wall-panel', { opacity: 1, duration: 0.5, ease: 'power2.out' });
  })
  .call(function() {
    gsap.to(winnerCard, { boxShadow: '0 0 60px rgba(255,215,0,0.8)', duration: 0.5, ease: 'power2.out' });
  })
  .call(() => {
    gsap.to(els.trophyDisplay, { opacity: 1, y: 0, duration: 0.8, ease: 'back.out(1.7)' });
    gsap.from(els.trophyDisplay, { y: -50, duration: 0.8, ease: 'back.out(1.7)' }, '<');
    gsap.to(els.championSpotlight, { opacity: 1, duration: 0.8, ease: 'power2.out' });
    gsap.to(els.championRays, { opacity: 0.6, duration: 1, ease: 'power2.out' });
    cameraZoom(1.04, 1.15);
  })
  .to({}, { duration: 15 });
  return tl;
}
// =========================================================
// Full Winners List Popup (scrollable text list)
// =========================================================
function buildWinnersList() {
  const board = document.getElementById('winnerlist-board');
  const after = board.querySelector('.winnerlist-after');
  board.innerHTML = '';
  if (after) board.appendChild(after);

  const fragment = document.createDocumentFragment();

  // Champion
  const champ = demoData.winners.grandPrize[0];
  if (champ) {
    const cSection = document.createElement('div');
    cSection.innerHTML = `<div class="winnerlist-section-title wl-champ">${_cfg('winnersChampTitle', '🏆 CHAMPION')}</div>`;
    fragment.appendChild(cSection);
    const cItem = document.createElement('div');
    cItem.className = 'winnerlist-item';
    cItem.innerHTML = `<span class="wl-rank">#1</span><span class="wl-flag">${champ.flag}</span><span class="wl-name">${champ.name}</span><span class="wl-id">#${champ.id}</span>`;
    fragment.appendChild(cItem);
  }

  // Runner ups
  const rSection = document.createElement('div');
  rSection.innerHTML = `<div class="winnerlist-section-title wl-runner">${_cfg('winnersRunnerTitle', '🥈 RUNNER UPS')}</div>`;
  fragment.appendChild(rSection);
  demoData.winners.runnerUp.forEach((p, i) => {
    const item = document.createElement('div');
    item.className = 'winnerlist-item';
    item.innerHTML = `<span class="wl-rank">#${p.revealOrder || i + 2}</span><span class="wl-flag">${p.flag}</span><span class="wl-name">${p.name}</span><span class="wl-id">#${p.id}</span>`;
    fragment.appendChild(item);
  });

  // Third prize
  const tSection = document.createElement('div');
  tSection.innerHTML = `<div class="winnerlist-section-title wl-third">${_cfg('winnersThirdTitle', '🥉 THIRD PRIZE WINNERS')}</div>`;
  fragment.appendChild(tSection);
  demoData.winners.thirdPrize.forEach((p, i) => {
    const item = document.createElement('div');
    item.className = 'winnerlist-item';
    item.innerHTML = `<span class="wl-rank">#${p.revealOrder || i + 7}</span><span class="wl-flag">${p.flag}</span><span class="wl-name">${p.name}</span><span class="wl-id">#${p.id}</span>`;
    fragment.appendChild(item);
  });

  board.insertBefore(fragment, after);
}


// =========================================================
// timeline.js
// =========================================================
function buildMasterTimeline(els) {
  const masterTL = gsap.timeline({ paused: true, defaults: { ease: 'power3.inOut' },
    onStart: () => { document.getElementById('hud').classList.add('visible'); }
  });
  masterTL
    .addLabel('hero').add(heroAnimation(els))
    .addLabel('opening').add(openingAnimation(els))
    .addLabel('wall').add(() => { showScene('ceremony'); }, 'wall').add(wallAnimation(els), 'wall+=0.1')
    .addLabel('third').add(thirdPrizeAnimation(els))
    .addLabel('runner').add(runnerUpAnimation(els))
    .addLabel('champion').add(championAnimation(els))
    .addLabel('winnerlist').add((() => {
      const tl = gsap.timeline();
      const popup = document.getElementById('winnerlist-popup');
      tl.call(() => {
        sound.stopAll();
        // Hide champion panel and restore wall
        const champPanel = document.getElementById('champion-panel');
        champPanel.classList.remove('active');
        champPanel.style.opacity = '0';
        document.querySelectorAll('.scene-ceremony .participant-card').forEach(c => {
          c.style.opacity = '1';
          c.style.filter = 'none';
        });
        gsap.to('.wall-panel', { opacity: 0, duration: 0.3, ease: 'power2.out' });
        cameraReset();
        buildWinnersList();
        popup.classList.add('visible');
        gsap.fromTo(popup.querySelector('.winner-popup'), { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' });
        masterTL.pause(); // End here — no further scenes
      });
      return tl;
    })())
  return masterTL;
}

// =========================================================
// main.js
// =========================================================
function startCeremony(els, Lenis) {
  gsap.to(els.loader, { opacity: 0, duration: 0.6, ease: 'power2.inOut', onComplete: () => { els.loader.classList.add('hidden'); } });
  createParticipantCards(demoData.participants);

  if (Lenis) {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, wrapper: window, content: document.documentElement });
    gsap.ticker.add((time) => { lenis.raf(time * 1000); }); gsap.ticker.lagSmoothing(0);
  }

  sound.init();
  sound.initSFX(window.WC_CONFIG || {});
  particles.init();
  const startAudio = () => {
    sound.resume();
    sound.startAmbience();
    sound.startMusic();
    document.removeEventListener('click', startAudio);
    document.removeEventListener('touchstart', startAudio);
  };
  sound.startMusic();
  document.addEventListener('click', startAudio);
  document.addEventListener('touchstart', startAudio);

  const masterTL = buildMasterTimeline(els);
  masterTL.play();
  return masterTL;
}

function init() {
  if (!window.gsap) {
    console.error("GSAP is not loaded!");
    const loader = document.getElementById('loader');
    if (loader) { loader.innerHTML = `<div style="color: #ff6b6b; text-align: center; font-family: sans-serif; max-width: 400px; padding: 20px;"><h2 style="margin-bottom: 10px;">${_cfg('errorTitle', 'Initialization Error')}</h2><p>${_cfg('errorBody', 'GSAP library failed to load.')}</p><p style="margin-top: 10px; font-size: 12px; color: #aaa;">${_cfg('errorFooter', 'Please ensure you are connected to the internet.')}</p></div>`; }
    return;
  }
  const { gsap, Lenis } = window;
  const els = {
    hero: document.getElementById('scene-hero'), heroTitle: document.querySelector('.hero-title'), heroEyebrow: document.querySelector('.hero-eyebrow'), heroSubtitle: document.querySelector('.hero-subtitle'), heroHint: document.querySelector('.hero-hint'), heroContent: document.querySelector('.hero-content'), countdownWrapper: document.getElementById('countdown-wrapper'), countdownNumber: document.getElementById('countdown-number'),
    opening: document.getElementById('scene-opening'), openingContent: document.querySelector('.opening-content'), openingEyebrow: document.querySelector('.opening-eyebrow'), openingStats: document.querySelectorAll('.opening-stat'), openingTagline: document.querySelector('.opening-tagline'),
    ceremony: document.getElementById('scene-ceremony'), wallPanel: document.getElementById('wall-panel'), participantWall: document.getElementById('participant-wall'), championPanel: document.getElementById('champion-panel'), championSpotlight: document.querySelector('.champion-spotlight'), championRays: document.querySelector('.champion-rays'), cyclingDisplay: document.getElementById('cycling-display'), cyclingName: document.getElementById('cycling-name'), championCardContainer: document.getElementById('champion-card-container'), trophyDisplay: document.getElementById('trophy-display'), championInfo: document.getElementById('champion-info'), championMeta: document.getElementById('champion-meta'),
    
    hud: document.getElementById('hud'), muteToggle: document.getElementById('muteToggle'), remainingCount: document.getElementById('remaining-count'), winnersCount: document.getElementById('winners-count'),
    loader: document.getElementById('loader'),
    schedule: document.getElementById('scene-schedule'),
    scheduleStartBtn: document.getElementById('scheduleStartBtn')
  };

  // Dev panel setup — runs before mode check so it works in both paths
  if (!window.__tl) {
    window.__tl = null;
    window.__goto = function(label) {
      var tl = window.__masterTL;
      if (!tl) { console.warn('No master timeline yet'); return; }
      if (tl.labels && tl.labels[label] !== undefined) { tl.pause(); tl.time(tl.labels[label]); tl.pause(); }
      else { console.warn('Unknown label "' + label + '". Available:', Object.keys(tl.labels || {})); return; }
      var pauseBtn = document.getElementById('devPauseBtn');
      if (pauseBtn) pauseBtn.textContent = '\u25B6 Resume';
    };
    window.__pause = function() { var tl = window.__masterTL; if (tl) tl.pause(); };
    window.__resume = function() { var tl = window.__masterTL; if (tl) tl.play(); };
    window.__labels = function() { var tl = window.__masterTL; return tl ? Object.keys(tl.labels || {}) : []; };
    // Wire dev panel buttons
    var devPanel = document.getElementById('devPanel');
    if (devPanel) {
      var devBtns = Array.from(devPanel.querySelectorAll('.dev-scene-btn'));
      devBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var label = btn.getAttribute('data-scene');
          if (window.__goto) window.__goto(label);
          devBtns.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
        });
      });
      var pauseBtn = document.getElementById('devPauseBtn');
      if (pauseBtn) {
        pauseBtn.addEventListener('click', function() {
          var tl = window.__masterTL;
          if (!tl) return;
          if (tl.paused()) { tl.play(); pauseBtn.textContent = '\u23F8 Pause'; }
          else { tl.pause(); pauseBtn.textContent = '\u25B6 Resume'; }
        });
      }
      var toggleBtn = document.getElementById('devPanelToggle');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function() {
          var body = document.getElementById('devPanelBody');
          if (body) {
            var collapsed = body.classList.toggle('collapsed');
            toggleBtn.textContent = collapsed ? '+' : '\u2212';
          }
        });
      }
    }
  }

  const isScheduleMode = els.schedule && els.schedule.classList.contains('active');
  if (isScheduleMode) {
    els.loader.classList.add('hidden');
    els.loader.style.opacity = '0';
    console.log('[WCEREMONY] Schedule mode active — ceremony paused');
    els.muteToggle.addEventListener('click', () => { const m = sound.toggleMute(); els.muteToggle.classList.toggle('muted', m); });
    const playBtn = document.getElementById('schedulePlayBtn');
    if (playBtn) {
      playBtn.addEventListener('click', () => {
        sound.resume();
        sound.startAmbience();
        sound.restartMusic();
        playBtn.classList.add('playing');
        playBtn.textContent = '♪ NOW PLAYING';
      });
    }

    // Volume control
    var volumeControl = document.getElementById('volumeControl');
    var volumeTrack = document.getElementById('volumeTrack');
    var volumeFill = document.getElementById('volumeFill');
    var volumeThumb = document.getElementById('volumeThumb');
    var volumeIcon = document.getElementById('volumeIcon');

    function updateVolumeUI(level, isMuted) {
      if (!volumeFill || !volumeThumb) return;
      var pct = Math.max(0, Math.min(100, level || 0));
      volumeFill.style.width = pct + '%';
      volumeThumb.style.left = pct + '%';
      if (volumeIcon) {
        volumeIcon.textContent = pct === 0 || isMuted ? '✕' : (pct < 33 ? '♩' : (pct < 66 ? '♪' : '♫'));
        volumeIcon.classList.toggle('muted', pct === 0 || isMuted);
      }
    }

    window._volumeUpdate = updateVolumeUI;

    (function initVolume() {
      if (!volumeTrack || !volumeFill || !volumeThumb) return;
      var dragging = false;
      var startVol = sound.getVolume ? sound.getVolume() : 80;
      sound.setVolume(startVol);
      updateVolumeUI(startVol, sound.isMuted);

      function setVolFromEvent(e) {
        var rect = volumeTrack.getBoundingClientRect();
        var x = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
        var pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
        sound.setVolume(pct);
        updateVolumeUI(pct, sound.isMuted);
      }

      volumeTrack.addEventListener('mousedown', function(e) { dragging = true; volumeThumb.classList.add('dragging'); setVolFromEvent(e); });
      document.addEventListener('mousemove', function(e) { if (dragging) { setVolFromEvent(e); } });
      document.addEventListener('mouseup', function() { if (dragging) { dragging = false; volumeThumb.classList.remove('dragging'); volumeThumb.classList.add('volume-pulse'); setTimeout(function() { volumeThumb.classList.remove('volume-pulse'); }, 300); } });

      volumeTrack.addEventListener('touchstart', function(e) { dragging = true; volumeThumb.classList.add('dragging'); setVolFromEvent(e); }, { passive: true });
      document.addEventListener('touchmove', function(e) { if (dragging) { setVolFromEvent(e); } }, { passive: true });
      document.addEventListener('touchend', function() { if (dragging) { dragging = false; volumeThumb.classList.remove('dragging'); } });

      if (volumeIcon) {
        volumeIcon.addEventListener('click', function() {
          var m = sound.toggleMute();
          updateVolumeUI(m ? 0 : (sound.getVolume ? sound.getVolume() : 80), m);
        });
      }
    })();

    var cfg = window.WC_CONFIG || {};
    var scheduleDateStr = cfg.scheduleDate;
    var scheduleTzDisplay = cfg.scheduleTimezone || 'Both';

    function padNum(n) { return n < 10 ? '0' + n : '' + n; }

    function parseScheduleDate(str) {
      var p = str.trim().split(/[\s\/\-:]+/);
      if (p.length >= 5) {
        return {
          year: parseInt(p[0]),
          month: parseInt(p[1]),
          day: parseInt(p[2]),
          hour: parseInt(p[3]),
          minute: parseInt(p[4])
        };
      }
      return null;
    }

    function scheduleToUtc(parts, inputTz) {
      var utcMs = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, 0);
      var offsetHours = (inputTz === 'EST') ? 5 : 7;
      return new Date(utcMs + offsetHours * 3600000);
    }

    function formatTzDisplay(utcDate, tz) {
      if (!utcDate || isNaN(utcDate.getTime())) return '';
      var tzId = tz === 'EST' ? 'America/New_York' : 'America/Los_Angeles';
      try {
        return utcDate.toLocaleString('en-US', { timeZone: tzId, year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }) + ' ' + tz;
      } catch (e) {
        return utcDate.toLocaleString('en-US') + ' ' + tz;
      }
    }

    function updateCountdownUI(days, hours, minutes, seconds) {
      document.getElementById('schedule-days').textContent = padNum(days);
      document.getElementById('schedule-hours').textContent = padNum(hours);
      document.getElementById('schedule-minutes').textContent = padNum(minutes);
      document.getElementById('schedule-seconds').textContent = padNum(seconds);
    }

    function wireStartButtonOnce() {
      if (!els.scheduleStartBtn) return;
      els.scheduleStartBtn.disabled = false;
      els.scheduleStartBtn.textContent = '\u25B6 START CEREMONY';
      els.scheduleStartBtn.addEventListener('click', function startClick() {
        showScene('hero');
        var masterTL = startCeremony(els, Lenis);
        window.__masterTL = masterTL;
        var skipBtn = document.getElementById('skip-btn');
        if (skipBtn) {
          skipBtn.addEventListener('click', function skipClick() {
            var labels = masterTL.labels;
            var current = masterTL.time();
            var next = null;
            Object.keys(labels).forEach(function(k) {
              var t = labels[k];
              if (t > current + 0.1 && (next === null || t < next)) next = t;
            });
            if (next !== null) { masterTL.time(next); } else { masterTL.progress(1); }
          });
        }
      }, { once: true });
    }

    // Show schedule date in configured timezone(s)
    var parsed = scheduleDateStr ? parseScheduleDate(scheduleDateStr) : null;
    var inputTz = (scheduleTzDisplay === 'EST') ? 'EST' : 'PDT';
    var targetDate = parsed ? scheduleToUtc(parsed, inputTz) : null;

    if (parsed && targetDate && !isNaN(targetDate.getTime())) {
      var pdtEl = document.getElementById('schedule-date-pdt');
      var estEl = document.getElementById('schedule-date-est');
      var sepEl = document.getElementById('schedule-date-sep');
      if (scheduleTzDisplay === 'PDT' || scheduleTzDisplay === 'Both') {
        pdtEl.textContent = formatTzDisplay(targetDate, 'PDT');
      }
      if (scheduleTzDisplay === 'EST' || scheduleTzDisplay === 'Both') {
        estEl.textContent = formatTzDisplay(targetDate, 'EST');
      }
      if (sepEl && scheduleTzDisplay === 'Both') {
        sepEl.style.display = 'inline';
      }
    }

    if (!parsed || !targetDate || isNaN(targetDate.getTime())) {
      // No date set — show 00, button works immediately
      updateCountdownUI(0, 0, 0, 0);
      wireStartButtonOnce();
    } else {
      var now = new Date();
      if (targetDate.getTime() <= now.getTime()) {
        // Date already passed
        updateCountdownUI(0, 0, 0, 0);
        wireStartButtonOnce();
      } else {
        // Countdown active — disable button until target
        if (els.scheduleStartBtn) {
          els.scheduleStartBtn.disabled = true;
          els.scheduleStartBtn.textContent = '\u23F3 WAITING...';
        }
        var schedInterval = setInterval(function() {
          var diff = targetDate.getTime() - new Date().getTime();
          if (diff <= 0) {
            clearInterval(schedInterval);
            updateCountdownUI(0, 0, 0, 0);
            wireStartButtonOnce();
            return;
          }
          var d = Math.floor(diff / 86400000);
          var h = Math.floor((diff % 86400000) / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          updateCountdownUI(d, h, m, s);
        }, 1000);
      }
    }
    return;
  }

  const masterTL = startCeremony(els, Lenis);
  window.__masterTL = masterTL;

  // Skip button — jumps to the next label
  const skipBtn = document.getElementById('skip-btn');
  if (skipBtn) {
    skipBtn.addEventListener('click', () => {
      const labels = masterTL.labels;
      const current = masterTL.time();
      let next = null;
      Object.keys(labels).forEach(k => {
        const t = labels[k];
        if (t > current + 0.1 && (next === null || t < next)) next = t;
      });
      if (next !== null) {
        masterTL.time(next);
      } else {
        masterTL.progress(1);
      }
    });
  }

  // Keep ceremony running when tab is backgrounded — fast-forward on return
  if (window.WC_CONFIG && window.WC_CONFIG.enableBackgroundFastforward !== false) {
    let hiddenAt = 0;
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        hiddenAt = performance.now();
      } else if (hiddenAt && !masterTL.paused()) {
        const elapsed = (performance.now() - hiddenAt) / 1000;
        const target = Math.min(masterTL.time() + elapsed, masterTL.duration());
        if (target > masterTL.time() + 0.5) {
          masterTL.time(target);
        }
        hiddenAt = 0;
      }
    });
  }

  els.muteToggle.addEventListener('click', () => { const muted = sound.toggleMute(); els.muteToggle.classList.toggle('muted', muted); });

  console.log('%c🏆 Winner Ceremony initialized', 'color: #F9BBC4; font-size: 16px; font-weight: bold;');
}

if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
